// extracted by mini-css-extract-plugin
module.exports = {"SimpleContent":"SimpleContent_SimpleContent__1IejM"};